import { render } from "./CGUContent.vue?vue&type=template&id=1fe67ace&scoped=true"
import script from "./CGUContent.vue?vue&type=script&lang=js"
export * from "./CGUContent.vue?vue&type=script&lang=js"

import "./CGUContent.vue?vue&type=style&index=0&id=1fe67ace&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe67ace"]])

export default __exports__